import { rankWith, isObjectControl, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const jsonTextAreaTester = rankWith(
  4,
  (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) => {
    if (!isControl(uischema) || !isObjectControl(uischema, schema, context)) {
      return false;
    }

    const path = uischema.scope;
    const propertySchema =
      context.rootSchema?.properties?.[path.split('/').pop() ?? ''];

    return (propertySchema as any)?.['x-widget'] === 'json-textarea';
  }
);
